import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { Link, Redirect, Route } from 'react-router-dom';
import PollBanStudentList from './PollBanStudentList';
import { FormattedMessage } from 'react-intl';


export default class PollBanCourseList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true

        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getCourse = this.getCourse.bind(this);
    }
    // imam pristup id ankete proslijedjen preko location(link)
    componentDidMount() {
        this.getCourse();
    }
    getCourse() {
        // treba da se vrate svi predmeti a ne samo koji imaju odg

        let obj = {
            id: null
        };

        axios.post(`/questionnaire/staff/course-implementations/${JSON.parse(localStorage.getItem('poll')).pollId}/`, { ...obj })
            .then(res => {
                const courses = res.data;
                this.setState({ data: courses, loading: false });
            })
            .catch(err => {
                this.setState({ loading: false });
                toast('Došlo je do greške, nije moguće prikazati predmete ankete.');
                console.log('Failed to fetch courses.');
            });
    }


    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.data;
    }


    render() {
        if (this.state.showResults === true) {
            return (<FormattedMessage id="route.accessStudents">
                {(msg) => (<Redirect push to={{ pathname: msg }} />)}
            </FormattedMessage>);
        }
        return (
            <div>
                <Header as="h2"> <FormattedMessage id="poll.polls" /> </Header>
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"><FormattedMessage id="poll.coursesOnPoll" /></Header></Segment>
                    <Segment>{this.state.loading ? <Loader active inline="centered" /> :
                        this.getDataToRender().length ? <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row >
                                    <Table.HeaderCell >
                                        <FormattedMessage id="common.course" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell >
                                        <FormattedMessage id="common.courseCode" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell >
                                        ECTS
                                    </Table.HeaderCell>

                                    <Table.HeaderCell colSpan="1" ></Table.HeaderCell>


                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.getDataToRender().map((el, index) =>
                                    (<Table.Row
                                        key={index}
                                        onClick={() => {
                                            localStorage.setItem('courseId', el.courseImplementationId);
                                            localStorage.setItem('courseName', el.courseImplementationName);
                                            this.setState({ showResults: true });
                                        }}
                                    >
                                        <Table.Cell verticalAlign="middle">
                                            {el.courseImplementationName ? el.courseImplementationName : '/'}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.courseCode ? el.courseCode : '/'}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.ects ? el.ects : '/'}
                                        </Table.Cell>

                                        <Table.Cell verticalAlign="middle" textAlign="center" colSpan="1">
                                            {/* link */}

                                            <Button
                                                onClick={() => {
                                                    localStorage.setItem('courseId', el.courseImplementationId);
                                                    localStorage.setItem('courseName', el.courseImplementationName);
                                                    this.setState({ showResults: true });
                                                }}

                                                basic="true"
                                                color="blue"
                                                size="small"
                                            > <FormattedMessage id="common.students" />

                                            </Button>


                                        </Table.Cell>
                                    </Table.Row>))}
                            </Table.Body>

                        </Table> : <FormattedMessage id="poll.noCoursesMess" />
                    } </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/PollBan/PollBanCourseList.js